import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardShell from "../components/DashboardShell";
import { Wrench, BookOpen, Download, BarChart3, Newspaper } from "lucide-react";
import InvestigationTools from "../components/tools/InvestigationTools";
import KnowledgeBase from "../components/tools/KnowledgeBase";
import DownloadsTab from "../components/tools/DownloadsTab";
import AnalyticsTab from "../components/tools/AnalyticsTab";
import CyberNews from "../components/tools/CyberNews";

const TABS = [
  { key: "investigation", label: "Investigation Tools", icon: Wrench, Component: InvestigationTools },
  { key: "knowledge", label: "Knowledge Base", icon: BookOpen, Component: KnowledgeBase },
  { key: "downloads", label: "Downloads", icon: Download, Component: DownloadsTab },
  { key: "analytics", label: "Analytics", icon: BarChart3, Component: AnalyticsTab },
  { key: "news", label: "Cyber News", icon: Newspaper, Component: CyberNews },
];

export default function ToolsPage() {
  const [params, setParams] = useSearchParams();
  const active = params.get("tab") || "investigation";
  const Active = (TABS.find((t) => t.key === active) || TABS[0]).Component;

  return (
    <DashboardShell>
      <div className="space-y-6" data-testid="tools-page">
        <div>
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.32em] text-[#39ff14]">// 03 / Tools</div>
          <h1 className="text-2xl lg:text-3xl font-semibold mt-1">Cyber Investigation Toolkit</h1>
        </div>

        <div className="flex flex-wrap gap-2 border-b border-[rgba(0,170,255,0.18)] pb-1" data-testid="tools-tabs">
          {TABS.map(({ key, label, icon: Icon }) => {
            const on = key === active;
            return (
              <button
                key={key}
                onClick={() => setParams({ tab: key })}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-t-md text-xs font-mono-tech uppercase tracking-[0.16em] border-b-2 transition-all ${on ? "border-[#00aaff] text-[#00aaff] bg-[#00aaff]/5" : "border-transparent text-[#94a3b8] hover:text-white"}`}
                data-testid={`tools-tab-${key}`}
              >
                <Icon size={13} /> {label}
              </button>
            );
          })}
        </div>

        <Active />
      </div>
    </DashboardShell>
  );
}
